import styled from 'styled-components';

export const ContentWrapperStyled = styled.div`
  position: relative;
  min-height: 30rem;
`;
